export const plans = {
  enterprise: {
    name: 'Enterprise',
    canonical: 'enterprise',
  },
  essential: {
    name: 'Essential',
    canonical: 'essential',
  },
  freeTrial: {
    name: 'Free trial',
    canonical: 'free_trial',
    daysDefault: 15,
  },
  platformTeams: {
    name: 'plans.platformTeams.name',
    canonical: 'platform_teams',
    description: 'plans.platformTeams.description',
  },
  endUsers: {
    name: 'plans.endUsers.name',
    canonical: 'end_users',
    description: 'plans.endUsers.description',
  },
}

export const thresholds = {
  // time thresholds (absolute values) mean 'if less than <value> it is <key>'
  time: {
    critical: 3,
    warning: 7,
  },
  // members thresholds (percentage values) mean 'if less than <value> it is <key>'
  members: {
    critical: 10,
    warning: 50,
  },
}
